var ConfigLoader = (function () {
    function ConfigLoader() {
    }
    return ConfigLoader;
}());
export { ConfigLoader };
var ConfigStaticLoader = (function () {
    function ConfigStaticLoader(settings) {
        this.settings = settings;
    }
    ConfigStaticLoader.prototype.loadSettings = function () {
        return Promise.resolve(this.settings);
    };
    return ConfigStaticLoader;
}());
export { ConfigStaticLoader };



//////////////////
// WEBPACK FOOTER
// /Users/Nathan/Desktop/Computing Sciences/dissertation/pairgo/pairgo-ng/~/@ngx-config/core/src/config.loader.js
// module id = ../../../../@ngx-config/core/src/config.loader.js
// module chunks = 4